import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import GetApp from "@material-ui/icons/GetApp";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Dialog from "@material-ui/core/Dialog";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { redirectToLogout, getYesNoFromInt } from "common/SharedFn";
import { getAllServices, getAllServiceTypes, addService, updateService, getAllLaundries } from "../../network/ApiAxios";
import { Check, Block, Edit } from "@material-ui/icons";
import "react-datepicker/dist/react-datepicker.css";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage: 50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const ServicesTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [laundries, setLaundries] = useState([]);
  // const [countries, setCountries] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [addModal, setAddModal] = useState(false);
  const [nameEn, setNameEn] = useState("");
  const [nameAr, setNameAr] = useState("");
  const [shortDescriptionEn, setShortDescriptionEn] = useState("");
  const [shortDescriptionAr, setShortDescriptionAr] = useState("");
  const [descriptionEn, setDescriptionEn] = useState("");
  const [descriptionAr, setDescriptionAr] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [bagImageUrl, setBagImageUrl] = useState("");
  const [turnAroundTime, setTurnAroundTime] = useState("");
  const [mainServiceId, setMainServiceId] = useState(-1);
  const [isPerItem, setIsPerItem] = useState(0);
  const [isCategoryOnly, setIsCategoryOnly] = useState(0);
  const [isShowInService, setIsShowInService] = useState(1);
  const [showInApp, setShowInApp] = useState(1);
  const [orderNo, setOrderNo] = useState(1);
  const [price, setPrice] = useState(0.0);
  const [bagPrice, setBagPrice] = useState(0.0);
  const [detailDescriptionEn, setDetailDescriptionEn] = useState("");
  const [detailDescriptionAr, setDetailDescriptionAr] = useState("");
  const [colorText, setColorText] = useState("");
  const [colorBackground, setColorBackground] = useState("");
  // const [countryId, setCountryId] = useState(0);
  const [isActive, setIsActive] = useState(1);
  const [globalServiceTypes, setGlobalServiceTypes] = useState([]);
  const [servicePricings, setServicePricings] = useState([]);
  const [id, setId] = useState();
  const [executeUpdate, setExecuteUpdate] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  const [defaultLaundry, setDefaultLaundry] = useState(0);
  const [file, setFile] = React.useState(null);
  const [file2, setFile2] = React.useState(null);
  let history = useHistory();

  let fileInput = React.createRef();

  let bagFileInput = React.createRef();

  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let newFile = e.target.files[0];
    reader.onloadend = () => {
      setFile(newFile);
    };
    if (newFile) {
      reader.readAsDataURL(newFile);
    }
  };

  const handleBagImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let newFile = e.target.files[0];
    reader.onloadend = () => {
      setFile2(newFile);
    };
    if (newFile) {
      reader.readAsDataURL(newFile);
    }
  };

  const warningAlert = (title, message, action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const setCurrentRecord = (info) => {
    const { id, nameEn, nameAr, shortDescriptionEn, shortDescriptionAr, descriptionEn, descriptionAr, imageUrl, bagImageUrl, isActive, price, bagPrice, detailDescriptionEn, detailDescriptionAr, colorText, colorBackground, turnAroundTime, mainServiceId, defaultLaundry,
      isPerItem, isCategoryOnly, isShowInService, showInApp, orderNo, servicePricings } = info;
    setNameEn(nameEn);
    setNameAr(nameAr);
    setShortDescriptionEn(shortDescriptionEn);
    setShortDescriptionAr(shortDescriptionAr);
    setDescriptionEn(descriptionEn);
    setDescriptionAr(descriptionAr);
    setImageUrl(imageUrl);
    setBagImageUrl(bagImageUrl);
    setPrice(price);
    setBagPrice(bagPrice);
    setDetailDescriptionEn(detailDescriptionEn);
    setDetailDescriptionAr(detailDescriptionAr);
    setColorText(colorText);
    setColorBackground(colorBackground);
    // setCountryId(countryId);
    setIsActive(isActive);
    setServicePricings(servicePricings || []);
    setTurnAroundTime(turnAroundTime);
    setIsPerItem(isPerItem);
    setIsCategoryOnly(isCategoryOnly);
    setIsShowInService(isShowInService);
    setShowInApp(showInApp);
    setOrderNo(orderNo);
    if (mainServiceId == null) {
      setMainServiceId(-1);
    }
    else {
      setMainServiceId(mainServiceId);
    }
    if (defaultLaundry == null) {
      setDefaultLaundry(0);
    }
    else {
      setDefaultLaundry(defaultLaundry);
    }
    setId(id);
  };

  const clearCurrentRecord = () => {
    setNameEn("");
    setNameAr("");
    setShortDescriptionEn("");
    setShortDescriptionAr("");
    setDescriptionEn("");
    setDescriptionAr("");
    setImageUrl("");
    setBagImageUrl("");
    setPrice(0.0);
    setBagPrice(0.0);
    setIsPerItem(0);
    setIsCategoryOnly(0);
    setIsShowInService(1);
    setShowInApp(1);
    setOrderNo(1);
    setDetailDescriptionEn("");
    setDetailDescriptionAr("");
    setColorText("");
    setColorBackground("");
    setIsActive(1);
    setServicePricings([]);
    setFile(null);
    setMainServiceId(-1);
    setTurnAroundTime(0);
    setId();
    setDefaultLaundry(0);
    document.getElementById("imageFile").value = "";
    document.getElementById("bagImageFile").value = "";
  };

  const fetchServices = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try {
      const [response, responseLaundries, responseServiceTypes] = await Promise.all([
        getAllServices(),
        getAllLaundries(),
        getAllServiceTypes(),
      ]);
      const { data } = response;
      const serviceTypesPayload = responseServiceTypes.data;
      if (Array.isArray(serviceTypesPayload)) {
        setGlobalServiceTypes(serviceTypesPayload);
      } else if (serviceTypesPayload && Array.isArray(serviceTypesPayload.data)) {
        setGlobalServiceTypes(serviceTypesPayload.data);
      }
      // const responseCountries = await getAllCountries();
      if (data.result.isSuccess) {
        setLaundries(responseLaundries.data.data);
        const allServices = data.data;
        const rows = allServices.map((prop) => {
          const parentName = prop.mainServiceId
            ? (allServices.find(s => s.id === prop.mainServiceId) || {}).nameEn || prop.mainServiceId
            : null;
          return makeTableRow({ ...prop, mainServiceNameEn: parentName });
        });
        const mainRows = rows.filter(r => !r.mainServiceId);
        const subRows = rows.filter(r => !!r.mainServiceId);
        const grouped = [];
        mainRows.forEach(main => {
          grouped.push(main);
          subRows.filter(s => s.mainServiceId === main.id).forEach(sub => grouped.push(sub));
        });
        subRows.filter(s => !mainRows.find(m => m.id === s.mainServiceId)).forEach(s => grouped.push(s));
        setData(grouped);
        //setError("");
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    }
    catch (ex) {
      showErrorNotification("Failed to fetch services");
    }
    setIsLoading(false);
  };



  const addServiceAction = async () => {
    if (isPerItem === 1 && isCategoryOnly !== 1 && servicePricings.length === 0) {
      showErrorNotification("Please select at least one service type");
      return;
    }
    setIsLoading(true);
    try {
      const response = await addService(nameEn, nameAr, shortDescriptionEn, shortDescriptionAr, descriptionEn, descriptionAr, imageUrl, bagImageUrl, isActive, price, bagPrice, detailDescriptionEn, detailDescriptionAr, colorText, colorBackground, turnAroundTime, mainServiceId, defaultLaundry, isPerItem, isCategoryOnly, isShowInService, showInApp, orderNo, servicePricings, file, file2);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Service Added Successfully");
        setAddModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    }
    catch (ex) {
      showErrorNotification("Failed to add service");
      setIsLoading(false);
    }
  };


  const updateServiceAction = async () => {
    if (isPerItem === 1 && isCategoryOnly !== 1 && servicePricings.length === 0) {
      showErrorNotification("Please select at least one service type");
      return;
    }
    setExecuteUpdate(false);
    setIsLoading(true);
    try {
      const response = await updateService(id, nameEn, nameAr, shortDescriptionEn, shortDescriptionAr, descriptionEn, descriptionAr, imageUrl, bagImageUrl, isActive, price, bagPrice, detailDescriptionEn, detailDescriptionAr, colorText, colorBackground, turnAroundTime, mainServiceId, defaultLaundry, isPerItem, isCategoryOnly, isShowInService, showInApp, orderNo, servicePricings, file, file2);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Service Updated Successfully");
        setAddModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    }
    catch (ex) {
      showErrorNotification("Failed to update service");
      setIsLoading(false);
    }
  };


  useAsyncEffect(async () => {
    if (executeUpdate) {
      updateServiceAction();
    }
    else {
      fetchServices();
    }
  }, [executeUpdate, forceRefresh]);

  const makeTableRow = (info) => {
    info.isActiveText = getYesNoFromInt(info.isActive);
    info.isPerItemText = getYesNoFromInt(info.isPerItem);
    info.isCategoryOnlyText = getYesNoFromInt(info.isCategoryOnly);
    info.isShowInServiceText = getYesNoFromInt(info.isShowInService);
    info.showInAppText = getYesNoFromInt(info.showInApp);
    // for (var i=0; i < countries.length; i++) {
    //   if(countries[i].id == info.countryId){
    //     info.countryText = countries[i].nameEn;
    //     break;
    //   }
    // }
    return {
      ...info,
      image: (
        <img src={info.imageUrl} width="50px" />
      ),
      actions: (
        <div className="actions-right">
          <Tooltip title="Edit">
            <Button size="small"
              classes={{
                root: classes.buttonContainedWarning,
              }}
              variant="contained"
              style={{ marginLeft: "5px" }}
              onClick={() => {
                clearCurrentRecord();
                setCurrentRecord(info);
                setAddModal(true);
              }}>
              <Box component={Edit} />
            </Button>
          </Tooltip>

          <div style={{ display: "inline-block" }}>
            {info.isActive == 1 ? (
              <Tooltip title="Disable">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedInfo,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                    warningAlert("Disable Service", "Are you sure you would like to disable the service " + info.nameEn + "?", async () => {
                      setCurrentRecord(info);
                      setIsActive(Math.abs(info.isActive - 1));
                      setAlert(null);
                      setExecuteUpdate(true);

                    })
                  }}
                >
                  <Box component={Block} />
                </Button>
              </Tooltip>
            ) : (
              <Tooltip title="Enable">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedSuccess,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                    warningAlert("Enable Service", "Are you sure you would like to enable the service " + info.nameAr + "?", async () => {
                      setCurrentRecord(info);
                      setIsActive(Math.abs(info.isActive - 1));
                      setAlert(null);
                      setExecuteUpdate(true);
                    })
                  }}
                >
                  <Box component={Check} />
                </Button>
              </Tooltip>
            )}
          </div>
        </div>
      ),
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >

        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>

              <div style={{ width: "100%" }}>
                <ToolkitProvider
                  data={data}
                  keyField="id"
                  columns={[
                    {
                      dataField: "id",
                      text: "ID",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "image",
                      text: "Image",
                      sort: false,
                      csvExport: false,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "nameEn",
                      text: "Name English",
                      sort: true,
                      style: { 'whiteSpace': 'normal' },
                      formatter: (cell, row) => row.mainServiceId
                        ? <span style={{ paddingLeft: "24px", color: "#555", display: "block" }}>↳ {cell}</span>
                        : <strong>{cell}</strong>,
                    },
                    {
                      dataField: "nameAr",
                      text: "Name Arabic",
                      sort: true,
                      style: { 'whiteSpace': 'normal' },
                      formatter: (cell, row) => row.mainServiceId
                        ? <span style={{ paddingRight: "24px", color: "#555", display: "block", textAlign: "right" }}>↳ {cell}</span>
                        : <strong>{cell}</strong>,
                    },
                    // {
                    //   dataField: "price",
                    //   text: "Price Per Item",
                    //   sort: true,
                    //   style: {'whiteSpace': 'normal'}
                    // },
                    {
                      dataField: "bagPrice",
                      text: "Price",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "descriptionEn",
                      text: "Short Description English",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "descriptionAr",
                      text: "Short Description Arabic",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "detailDescriptionEn",
                      text: "Detailed Description English",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "detailDescriptionAr",
                      text: "Detailed Description Arabic",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "colorText",
                      text: "Text Color",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "colorBackground",
                      text: "Background Color",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "turnAroundTime",
                      text: "Turn Around Time",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "mainServiceNameEn",
                      text: "Main Service",
                      sort: true,
                      style: { 'whiteSpace': 'normal' },
                      formatter: (cell) => cell ? <span style={{ color: "#1a73e8" }}>{cell}</span> : <span style={{ color: "#aaa" }}>—</span>,
                    },
                    // {
                    //   dataField: "countryText",
                    //   text: "Country",
                    //   sort: true,
                    //   style: {'whiteSpace': 'normal'}
                    // },
                    {
                      dataField: "isPerItemText",
                      text: "Is Per Item",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "isCategoryOnlyText",
                      text: "Is Category Only",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    }, {
                      dataField: "isShowInServiceText",
                      text: "Show In Service",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    }, {
                      dataField: "showInAppText",
                      text: "Show In App",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    }, {
                      dataField: "orderNo",
                      text: "Order Number",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "isActiveText",
                      text: "Is Enabled",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "actions",
                      classes: "actions-col",
                      headerClasses: "actions-col",
                      text: "Actions",
                      csvExport: false,
                    },
                  ]}
                  search
                  exportCSV
                >
                  {(props) => (
                                      <>
                  <CardHeader
                    style={{ paddingTop: "0.875rem", paddingBottom: "0.875rem" }}
                    title={
                      <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                        <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Services</Box>
                    </Box>
                        </>
                        <Tooltip title="Add new service">
                          <IconButton
                            size="small"
                            onClick={() => {
                                clearCurrentRecord();
                                setAddModal(true);
                              }}
                            style={{
                              width: 32, height: 32,
                              backgroundColor: "#fff",
                              border: "1px solid #5e72e4",
                              color: "#5e72e4",
                            }}
                          >
                            <AddIcon style={{ width: 18, height: 18 }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    }
                    action={
                      <Box
                        display="flex" alignItems="center" flexWrap="wrap"
                        justifyContent="flex-end"
                        style={{ gap: 8, marginTop: 8, marginRight: 8 }}
                      >
                        <div
                          id="datatable-basic_filter"
                          style={{ display: "flex", alignItems: "center", height: 40 }}
                        >
                          <SearchBar
                            className="form-control-sm"
                            placeholder="Search..."
                            style={{ height: 40, margin: 0, boxSizing: "border-box" }}
                            {...props.searchProps}
                          />
                        </div>
                          {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                          {/* </Tooltip> */}
                        <Tooltip title="Download CSV">
                          <span style={{ display: "flex" }}>
                            <ExportCSVButton
                              className="MuiButtonBase-root"
                              style={{
                                width: 40, height: 40, padding: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                border: "1px solid #172b4d", borderRadius: 8,
                                color: "#fff", backgroundColor: "#172b4d", cursor: "pointer",
                              }}
                              {...props.csvProps}
                            >
                              <GetApp style={{ width: 18, height: 18 }} />
                            </ExportCSVButton>
                          </span>
                        </Tooltip>
                      </Box>
                    }
                  />
                  <div className="table-responsive">
                                            <BootstrapTable
                        ref={componentRef}
                        {...props.baseProps}
                        bootstrap4={true}
                        pagination={pagination}
                        bordered={true}
                        striped={false}
                        rowStyle={(row) => row.mainServiceId
                          ? { backgroundColor: "#f9f9f9" }
                          : { backgroundColor: "#eef3fb", fontWeight: "bold" }
                        }
                        //filter={ filterFactory() }
                        noDataIndication={() =>
                          isLoading ? (
                            <Box
                              component={Grid}
                              container
                              justifyContent="center"
                              className="justify-content-center"
                            >
                              <div
                                className="text-center"
                                style={{ width: "20%" }}
                              >
                                <LoadingAnimation />{" "}
                              </div>
                            </Box>
                          ) : (
                            <h4>No Records</h4>
                          )
                        }
                        id="main-table"
                      />

                    </div>
                    </>
                  )}
                </ToolkitProvider>
              </div>
            </Card>
          </Grid>
        </Grid>
        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={addModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setAddModal(false)}
        >
          <DialogTitle
            disableTypography
            className={classes.modalHeader}
          >
            <h4 className={classes.modalTitle}>
              {id == null || id === "" ? "Add" : "Edit"} Service
            </h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>

              <FormGroup>
                <FormLabel>Name (English)</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Name (English)"
                  value={nameEn ?? ""}
                  onChange={(e) => setNameEn(e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Name (Arabic)</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Name (Arabic)"
                  value={nameAr ?? ""}
                  onChange={(e) => setNameAr(e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Is Category Only</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select value={isCategoryOnly} onChange={(e) => setIsCategoryOnly(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>

              <FormGroup>
                <FormLabel>Is Per Item</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select value={isPerItem} onChange={(e) => {
                    const val = e.target.value;
                    setIsPerItem(val);
                    if (val === 1 && servicePricings.length === 0 && globalServiceTypes.length > 0) {
                      setServicePricings([{ serviceTypeId: globalServiceTypes[0].id, price: "" }]);
                    }
                  }} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>

              {isPerItem === 1 && isCategoryOnly !== 1 && (
                <FormGroup>
                  <FormLabel>Service Types & Pricing</FormLabel>
                  <FormControl variant="outlined" fullWidth component="fieldset">
                    <FormGroup>
                      {(globalServiceTypes || []).map((type) => {
                        const pricing = servicePricings.find(p => p.serviceTypeId === type.id);
                        const isChecked = !!pricing;
                        return (
                          <div key={type.id} style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "8px" }}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={isChecked}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setServicePricings([...servicePricings, { serviceTypeId: type.id, price: "" }]);
                                    } else {
                                      setServicePricings(servicePricings.filter(p => p.serviceTypeId !== type.id));
                                    }
                                  }}
                                  color="primary"
                                />
                              }
                              label={type.nameEn}
                            />
                            {isChecked && (
                              <OutlinedInput
                                type="number"
                                placeholder="Price"
                                value={pricing.price}
                                onChange={(e) => {
                                  setServicePricings(servicePricings.map(p =>
                                    p.serviceTypeId === type.id ? { ...p, price: e.target.value } : p
                                  ));
                                }}
                                style={{ width: "130px" }}
                              />
                            )}
                          </div>
                        );
                      })}
                    </FormGroup>
                  </FormControl>
                </FormGroup>
              )}

              <FormGroup>
                <FormLabel>Main Service</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    value={mainServiceId}
                    onChange={(e) => setMainServiceId(e.target.value)}
                    IconComponent={KeyboardArrowDown}
                  >
                    <MenuItem value={-1}>NA</MenuItem>
                    {data.filter(srv => srv.isCategoryOnly === 1).map(function (srv, i) {
                      return <MenuItem value={srv.id}>{srv.nameEn}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </FormGroup>

              {/* <FormGroup>
                  <FormLabel>Price Per Item</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="Price Per Item"
                    value={price ?? ""}
                    onChange={(e) => setPrice(e.target.value)}
                  />
                </FormGroup> */}


              {isPerItem !== 1 && (
                <FormGroup>
                  <FormLabel>Price</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="Price"
                    value={bagPrice ?? ""}
                    onChange={(e) => setBagPrice(e.target.value)}
                  />
                </FormGroup>
              )}

              <FormGroup>
                <FormLabel>Short Description Orders Page (English)</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Short Description Orders Page (English)"
                  value={shortDescriptionEn ?? ""}
                  multiline={true}
                  rows={5}
                  onChange={(e) => setShortDescriptionEn(e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Short Description Orders Page (Arabic)</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Short Description Orders Page (Arabic)"
                  value={shortDescriptionAr ?? ""}
                  multiline={true}
                  rows={5}
                  onChange={(e) => setShortDescriptionAr(e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Short Description (English)</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Short Description (English)"
                  value={descriptionEn ?? ""}
                  multiline={true}
                  rows={5}
                  onChange={(e) => setDescriptionEn(e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Short Description (Arabic)</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Short Description (Arabic)"
                  value={descriptionAr ?? ""}
                  multiline={true}
                  rows={5}
                  onChange={(e) => setDescriptionAr(e.target.value)}
                />
              </FormGroup>


              <FormGroup>
                <FormLabel>Detailed Description (English)</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Detailed Description (English)"
                  value={detailDescriptionEn ?? ""}
                  multiline={true}
                  rows={5}
                  onChange={(e) => setDetailDescriptionEn(e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Detailed Description (Arabic)</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Detailed Description (Arabic)"
                  value={detailDescriptionAr ?? ""}
                  multiline={true}
                  rows={5}
                  onChange={(e) => setDetailDescriptionAr(e.target.value)}
                />
              </FormGroup>


              <FormGroup>
                <FormLabel>Text Color</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="#ffffffff"
                  value={colorText ?? ""}
                  onChange={(e) => setColorText(e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Background Color</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="#ffffffff"
                  value={colorBackground ?? ""}
                  onChange={(e) => setColorBackground(e.target.value)}
                />
              </FormGroup>


              <FormGroup>
                <FormLabel>Turn around time in hours</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="number"
                  placeholder="Turn around time"
                  value={turnAroundTime ?? ""}
                  onChange={(e) => setTurnAroundTime(e.target.value)}
                />
              </FormGroup>



              {/* <FormGroup>
                  <FormLabel>Country</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={countryId} onChange={(e) => setCountryId(e.target.value)} IconComponent={KeyboardArrowDown}>
                    {countries.map(function(country, i){
                        return <MenuItem value={country.id}>{country.nameEn}</MenuItem>;
                    })}
                    </Select>
                  </FormControl>
                </FormGroup> */}

              <FormGroup>
                <FormLabel>Default Laundry</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select value={defaultLaundry} onChange={(e) => setDefaultLaundry(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={0}>None</MenuItem>
                    {laundries.map(function (laundry, i) {
                      return <MenuItem value={laundry.id}>{laundry.name}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </FormGroup>

              <FormGroup>
                <FormLabel>Show In Service</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select value={isShowInService} onChange={(e) => setIsShowInService(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>
              <FormGroup>
                <FormLabel>Show In App</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select value={showInApp} onChange={(e) => setShowInApp(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>


              <FormGroup>
                <FormLabel>Order Number (Sequence)</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="number"
                  placeholder="Order Number"
                  value={orderNo ?? ""}
                  onChange={(e) => setOrderNo(e.target.value)}
                />
              </FormGroup>


              <FormGroup>
                <FormLabel>Is Enabled</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select value={isActive} onChange={(e) => setIsActive(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>

              <FormGroup>
                <FormLabel>Image</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <div className="fileinput">
                    <div className={"thumbnail"}>
                      <img src={imageUrl} width="100px" />
                    </div>
                    <input
                      type="file"
                      id="imageFile"
                      onChange={handleImageChange}
                      ref={fileInput}
                    />
                  </div>
                </FormControl>
              </FormGroup>

              <FormGroup>
                <FormLabel>Bag Image</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <div className="fileinput">
                    <div className={"thumbnail"}>
                      <img src={bagImageUrl} width="100px" />
                    </div>
                    <input
                      type="file"
                      id="bagImageFile"
                      onChange={handleBagImageChange}
                      ref={bagFileInput}
                    />
                  </div>
                </FormControl>
              </FormGroup>
            </form>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setAddModal(false)}
            >
              Cancel
            </Button>
            <Button
              onClick={() =>
                id == null || id === "" ? addServiceAction() : updateServiceAction()
              }

              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              {id == null || id === "" ? "Add" : "Update"}
            </Button>

          </DialogActions>
        </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default ServicesTable;
